import { Route } from 'vue-router';

export const getScreenName = (route: Route) => {
  let screenName = route?.name;

  if (screenName === 'due_debt_calendar') {
    const { tab = 'today' } = route.query;
    const dueDebtCalendarScreenName = {
      past: 'past_due',
      today: 'today',
      future: 'coming_up',
    };
    // @ts-ignore
    screenName = `debt_notes_due_date_calendar/${dueDebtCalendarScreenName[tab]}`;
  }

  return screenName;
};
